/**
 * 初始密码 / 账户密码规则：
 * - 至少 8 位
 * - 小写、大写、数字、符号四类中至少三类
 */
export function analyzePassword(value) {
  const password = value == null ? "" : String(value);
  const lower = /[a-z]/.test(password);
  const upper = /[A-Z]/.test(password);
  const digit = /\d/.test(password);
  const symbol = /[^A-Za-z0-9]/.test(password);
  const length = password.length >= 8;
  const typesCount = [lower, upper, digit, symbol].filter(Boolean).length;
  const valid = length && typesCount >= 3;

  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 10) score += 1;
  score += Math.min(typesCount, 3);

  let level = "none";
  if (password) {
    if (!valid || score <= 2) level = "weak";
    else if (score <= 3) level = "medium";
    else level = "strong";
  }

  return {
    lower,
    upper,
    digit,
    symbol,
    length,
    typesCount,
    valid,
    level,
  };
}
